export default __webpack_public_path__ + "static/media/LogoAlertaFavicon.3d679de7.png";